// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"87a38c66","290":"ccf346c9","453":"68693753","455":"e79d1ca8","606":"11213a1c","647":"e698fa75","687":"51e9338a","952":"943f850e","977":"255b6566"}[chunkId] + ".chunk.js";
};